import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import React from 'react'

export const DEFAULT_MAIN_COLOR = '#000'
export const DEFAULT_BORDER_COLOR = '#FFF'

const styles = () =>
  createStyles({
    root: {
      minWidth: 15,
      minHeight: 15,
      border: `solid 2px ${DEFAULT_BORDER_COLOR}`,
      borderRadius: '50%',
      background: DEFAULT_MAIN_COLOR,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.2)',
    },
  })

interface IColorDot extends WithStyles {
  borderColor?: string
  mainColor?: string
}

const ColorDot = (props: IColorDot) => {
  const { classes, mainColor = DEFAULT_MAIN_COLOR, borderColor = DEFAULT_BORDER_COLOR } = props

  return <div className={classes.root} style={{ background: mainColor, borderColor }} />
}

export default withStyles(styles)(ColorDot)
